export function minLengthValidation(inputData, minLength) {
  //para poder utilizarla en otros ficheros
  //validar que el formulario tenga min de 6 o 7 caracteres(minLength)
  const { value } = inputData;
  //antes de validar se resetear el valor de inputData
  removeClassErrorSuccess(inputData); //todo lo que tiene <input type="" etc>

  if (value.length >= minLength) {
    //si cumple el tamaÑo de caracteres
    inputData.classList.add("success"); //formulario correcto
    return true;
  } else {
    inputData.classList.add("error"); //formulario incorrecto
    return false;
  }
}
export function emailValidation(inputData) {
  // eslint-disable-next-line no-useless-escape
  const emailValid = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  const { value } = inputData;

  removeClassErrorSuccess(inputData);

  const resultValidation = emailValid.test(value); //valida si el correo esta bien
  if (resultValidation) {
    inputData.classList.add("success"); //correo correcto
    return true;
  } else {
    inputData.classList.add("error"); //correo incorrecto
    return false;
  }
}

function removeClassErrorSuccess(inputData) {
  //remover la clase de error y sucess del input que reciba
  inputData.classList.remove("success"); //clase success
  inputData.classList.remove("error"); //clase error
}
